skrilla.controller('createAffiliateCtrl', function ($scope, searchService, modalService, validationService) {
    var validation = validationService;
    $scope.validate = {}
    $scope.affiliate = {}

    $scope.create = function(){
        if(validate()){
            modalService.confirm("Are you sure you'd like to create this affiliate?", function(){
                searchService.post("affiliates", $scope.affiliate, "Affiliate successfully created.").then(function(){
                    modalService.dismissAll();
                })
            });
        }
    }

    function validate(){
        var inputs = [
            validation.buildFieldValidationObj("name", !validation.isEmpty($scope.affiliate.name), "Please enter a name"),
            validation.buildFieldValidationObj("email", validation.isEmail($scope.affiliate.email), "Please enter a valid email")
        ];
        return validation.validateForm(inputs, $scope.validate)
    }

});